import React from 'react';
import Modal from 'react-bootstrap/Modal';

import SampleCommentPanel from '@components/SampleCommentPanel';

const SampleComment = ({
	productId = null,
	showComment,
	setShowComment,
	sampleRequestId,
	brandInfo,
	postTypeFilter,
	postTypeId,
	topic,
	getPostUrl,
	addPostUrl,
	isProject = false,
	styleList = []
}) => {
	return (
		<Modal
			show={showComment}
			onHide={() => {
				setShowComment(false);
			}}
			className="modal-right task-conversation with-tag-person sample-task-coversation"
			aria-labelledby="example-custom-modal-styling-title"
		>
			<SampleCommentPanel
				productId={productId}
				brandName={brandInfo?.brandName}
				sampleRequestId={sampleRequestId}
				closeModal={() => {
					setShowComment(false);
				}}
				callback={() => {}}
				setDesignIdToView={() => {}}
				brandId={brandInfo?.brandId}
				postTypeFilter={postTypeFilter}
				getPostUrl={getPostUrl ? getPostUrl : 'fetchAllDesignComment'}
				addPostUrl={addPostUrl ? addPostUrl : 'addNewPost'}
				postTypeId={postTypeId}
				topic={topic}
				isProject={isProject}
				styleList={styleList}
			/>
		</Modal>
	);
};

export default SampleComment;
